class TokenApi {  

	static GetToken() {

		const parseStorage = JSON.parse(localStorage.u);
		// console.log(parseStorage, localStorage)
		return parseStorage;
		
	}

}

export default TokenApi;